// Enhanced quest data with more RPG elements
export const enhancedQuests = [
  {
    id: 1,
    name: 'PORTFOLIO OF SOULS',
    tech: 'React • TailwindCSS',
    status: 'IN PROGRESS',
    difficulty: 'NORMAL',
    location: 'Mirrorlands of Self',
    duration: '2 weeks (ongoing)',
    reward: '+600 XP, Amulet of Reflection',
    achievement: 'Built a responsive, themed portfolio showcasing skills and quests — a testament to both frontend finesse and inner purpose',
    lore: 'In the ethereal Mirrorlands, where code meets conviction, the dev-warrior crafts a digital relic. With Tailwind runes and React incantations, he summons a portal that reflects not just skills, but the will that drives them.',
    questGiver: 'Inner Voice'
  },
  {
    id: 2,
    name: 'QUOTE CASTER',
    tech: 'Python • FastAPI • Kafka • OpenAPI • Jinja2 • Kong Gateway • Grafana • Cursor IDE',
    status: 'COMPLETE',
    difficulty: 'NORMAL',
    location: 'Notification Dunes',
    duration: '2 months',
    reward: '+900 XP, Signal Blade of Sync',
    achievement: 'Crafted a real-time Quote Requesting backend that broadcasts state changes across realms using event-driven scrolls and API enchantments',
    lore: 'In the windswept Notification Dunes, a signal must be cast to the outer lands each time a request transforms. The dev-hero, armed with Pythonic magic and Kafka storms, weaves a saga of speed, clarity, and observability.',
    questGiver: 'Product Archmage'
  },
  {
    id: 4,
    name: 'GATES OF PERMISSION',
    tech: 'Java • Spring Framework • Spring Data • Spring Cloud Config',
    status: 'COMPLETE',
    difficulty: 'HARD',
    location: 'Citadel of Credentials',
    duration: '3 months',
    reward: '+850 XP, Keyring of Authority',
    achievement: 'Forged a User Access Management system safeguarding internal systems, integrating with cloud config magic and layered Spring enchantments',
    lore: 'Beyond the iron walls of the Citadel of Credentials, chaos threatened the sacred vaults. Only by invoking the Java spellbook and the sacred Spring runes could a Guardian craft the Gates of Permission, locking out intruders and empowering the worthy.',
    questGiver: 'Product Archmage'
  }, 
  {
    id: 5,
    name: 'SCORES OF JUDGMENT',
    tech: 'Python • Spark • CA Workload Automation • Linux • Distributed Analytics • Scripting',
    status: 'COMPLETE',
    difficulty: 'EXTREME',
    location: 'Hall of Loans',
    duration: '3 months',
    reward: '+950 XP, Scales of Precision',
    achievement: 'Engineered a lightning-fast loan scoring system that shrank calculation time from 3 days to 3 hours, wielding the power of distributed analytics and workload automation',
    lore: 'Within the austere Hall of Loans, where destinies are weighed, the dev-sage harnesses Spark’s flames and automation spirits to quicken the judgment of borrowers, ushering in an era of swift decisions and trust.',
    questGiver: 'Loan Operatives Council'
  },
  {
    id: 6,
    name: 'LAKEFORGE INITIATIVE',
    tech: 'Python • Spark • CA Workload Automation • Oracle • MSSQL • PostgreSQL • Shell Scripting',
    status: 'COMPLETE',
    difficulty: 'HARD',
    location: 'Delta Cascade',
    duration: '2 month',
    reward: '+700 XP, Chalice of Cleansed Streams',
    achievement: 'Built end‑to‑end pipelines that extract data from Oracle, MSSQL, and PostgreSQL realms, stage it in the deep Datalake, and purify it for analytics and reporting',
    lore: 'At the tumultuous Delta Cascade, torrents of raw data collide. Guided by workload automatons and Spark flames, the lone engineer channels each torrent into the sacred lake, transmuting chaos into crystalline insight.',
    questGiver: 'Chief Platform Sentinel • Data Oracles'
  },
  {
    id: 7,
    name: 'THE TRI-LAYERED ENGINE',
    tech: 'Linux • VMWare • Cassandra • Spark • Hadoop • Solr • Data Replication',
    status: 'COMPLETE',
    difficulty: 'EXTREME',
    location: 'Vaults of Velocity Bank',
    duration: '4 months',
    reward: '+1200 XP, Helm of Distributed Wisdom',
    achievement: 'Designed and built a three-tier distributed data platform—Cassandra for lightning-fast transactions, Spark for blazing analytics, and Hadoop as the deep storage lake—crafted single-handedly under pressure',
    lore: 'In the fortified Vaults of Velocity, ancient systems cried for rebirth. The lone dev-knight, entrusted by the Senior Engineer and an emissary from the Director’s Circle, assembled the Tri-Layered Engine—a behemoth to process, analyze, and store rivers of financial data in harmony.',
    questGiver: 'Chief Platform Sentinel • Code Warden'
  },
  {
    id: 8,
    name: "CLUSTER FORGE",
    tech: "Linux • Oracle DB • Networking • Storage • Load Balancer",
    status: "COMPLETE",
    difficulty: "EASY",
    location: "Test Lab Highlands",
    duration: "1 month",
    reward: "+500 XP, Sysadmin’s Gauntlets",
    achievement: "Forged a full-stack test cluster from raw systems — EXTREMEing Linux, configuring network and storage layers, balancing loads, and breathing life into Oracle DB",
    lore: "In the misty Test Lab Highlands, a young squire embarks on a sacred rite: forging a cluster strong enough to simulate the gods’ databases. With no map and only a Senior’s scroll, he faces the Trial of Configuration.",
    questGiver: "Code Warden"
  }
];